// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"394":"d87cbce2","804":"e0af188a"}[chunkId] + ".chunk.css";
};